import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

const VisitorCounter = () => {
    const [stats, setStats] = useState({
        total: 0,
        today: 0,
        week: 0,
        month: 0,
        online: 0,
        top_referers: []
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const recordVisit = async () => {
            try {
                await fetch('https://monevmedsos.manggaraibaratkab.go.id/apiwifi.php/visitor/record', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        page: window.location.pathname,
                        timestamp: new Date().toISOString()
                    })
                });
            } catch (error) {
                console.log('Failed to record visit:', error);
            }
        };

        const fetchStats = async () => {
            try {
                const response = await fetch('https://monevmedsos.manggaraibaratkab.go.id/apiwifi.php/visitor/stats');
                if (response.ok) {
                    const data = await response.json();
                    setStats(data);
                }
            } catch (error) {
                console.log('Failed to fetch visitor stats:', error);
            } finally {
                setLoading(false);
            }
        };

        // Record visit and fetch stats
        recordVisit();
        fetchStats();

        // Update stats every 30 seconds
        const interval = setInterval(fetchStats, 30000);

        return () => clearInterval(interval);
    }, []);

    const formatNumber = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    if (loading) {
        return (
            <div className="visitor-counter">
                <div className="counter-loading">
                    <i className="fas fa-chart-line"></i>
                    <span>Memuat Statistik Pengunjung</span>
                </div>
            </div>
        );
    }

    return (
        <div className="visitor-counter">
            <div className="counter-grid">
                <div className="counter-item total">
                    <div className="counter-icon">
                        <i className="fas fa-users"></i>
                    </div>
                    <div className="counter-info">
                        <span className="counter-number icon">{formatNumber(stats.total)}</span><br/>
                        <span className="counter-label">Total Pengunjung</span>
                    </div>
                </div>

                <div className="counter-item today">
                    <div className="counter-icon">
                        <i className="fas fa-calendar-day"></i>
                    </div>
                    <div className="counter-info">
                        <span className="counter-number icon">{formatNumber(stats.today)}</span><br/>
                        <span className="counter-label">Hari Ini</span>
                    </div>
                </div>

                <div className="counter-item week">
                    <div className="counter-icon">
                        <i className="fas fa-calendar-week"></i>
                    </div>
                    <div className="counter-info">
                        <span className="counter-number icon">{formatNumber(stats.week)}</span><br/>
                        <span className="counter-label">Minggu Ini</span>
                    </div>
                </div>

                <div className="counter-item month">
                    <div className="counter-icon">
                        <i className="fas fa-calendar-alt"></i>
                    </div>
                    <div className="counter-info">
                        <span className="counter-number icon">{formatNumber(stats.month)}</span><br/>
                        <span className="counter-label">Bulan Ini</span>
                    </div>
                </div>

                <div className="counter-item online">
                    <div className="counter-icon pulse">
                        <i className="fas fa-circle"></i>
                    </div>
                    <div className="counter-info">
                        <span className="counter-number icon">{formatNumber(stats.online)}</span><br/>
                        <span className="counter-label">Online Sekarang</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

function FooterOne() {
    return (
        <footer className="footer-wrapper footer-layout1">
            <div className="widget-area">
                <div className="container">
                    {/* <div className="newsletter-area">
                        <div className="newsletter-top">
                            <div className="row gy-4 align-items-center">
                                <div className="col-lg-5">
                                    <h2 className="newsletter-title text-capitalize mb-0">
                                        Dapatkan Update Terbaru Infrastruktur Telekomunikasi
                                    </h2>
                                </div>
                                <div className="col-lg-7">
                                    <form className="newsletter-form">
                                        <input
                                            className="form-control "
                                            type="email"
                                            placeholder="Masukkan Email Anda"
                                            required=""
                                        />
                                        <button type="submit" className="th-btn style3">
                                            Berlangganan <img src="/assets/img/icon/plane.svg" alt="" />
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="row justify-content-between">
                        <div className="col-md-6 col-xl-3">
                            <div className="widget footer-widget">
                                <div className="th-widget-about">
                                    <div className="about-logo">
                                        <Link to="/">
                                            <img src="/assets/img/koorditel.png" alt="Koorditel Kabupaten Manggarai Barat" />
                                        </Link>
                                    </div>
                                    <p className="about-text">
                                        Sistem Informasi Geografis Koorditel Kabupaten Manggarai Barat untuk monitoring 
                                        infrastruktur telekomunikasi dan lokasi WiFi publik. Mendukung pengembangan 
                                        jaringan telekomunikasi yang lebih baik dan merata di wilayah Manggarai Barat.
                                    </p>
                                    <div className="th-social">
                                        <Link to="https://www.facebook.com/">
                                            <i className="fab fa-facebook-f" />
                                        </Link>
                                        <Link to="https://www.twitter.com/">
                                            <i className="fab fa-twitter" />
                                        </Link>
                                        <Link to="https://www.linkedin.com/">
                                            <i className="fab fa-linkedin-in" />
                                        </Link>
                                        <Link to="https://www.whatsapp.com/">
                                            <i className="fab fa-whatsapp" />
                                        </Link>
                                        <Link to="https://instagram.com/">
                                            <i className="fab fa-instagram" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-auto">
                            <div className="widget widget_nav_menu footer-widget">
                                <h3 className="widget_title">Menu Utama</h3>
                                <div className="menu-all-pages-container">
                                    <ul className="menu">
                                        <li>
                                            <Link to="/">Beranda</Link>
                                        </li>
                                        <li>
                                            <Link to="/about">Tentang Kami</Link>
                                        </li>
                                        <li>
                                            <Link to="/">Peta Interaktif</Link>
                                        </li>
                                        <li>
                                            <Link to="/admin">Dashboard Admin</Link>
                                        </li>
                                        <li>
                                            <Link to="/contact">Hubungi Kami</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-auto">
                            <div className="widget footer-widget">
                                <h3 className="widget_title">Kontak & Informasi</h3>
                                <div className="th-widget-contact">
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets/img/icon/phone.svg" alt="img" />
                                        </div>
                                        <div className="details">
                                            <p>
                                                <Link to="tel:+6281234567890" className="info-box_link">
                                                    +62 812 3456 7890
                                                </Link>
                                            </p>
                                            <p>
                                                <Link to="tel:+6289876543210" className="info-box_link">
                                                    +62 898 7654 3210
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets/img/icon/envelope.svg" alt="img" />
                                        </div>
                                        <div className="details">
                                            <p>
                                                <Link
                                                    to="mailto:info@koorditel-manggarai-barat.go.id"
                                                    className="info-box_link"
                                                >
                                                    info@koorditel-manggarai-barat.go.id
                                                </Link>
                                            </p>
                                            <p>
                                                <Link
                                                    to="mailto:support@koorditel-manggarai-barat.go.id"
                                                    className="info-box_link"
                                                >
                                                    support@koorditel-manggarai-barat.go.id
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets/img/icon/location-dot.svg" alt="img" />
                                        </div>
                                        <div className="details">
                                            <p>Kantor Koorditel Kabupaten Manggarai Barat</p>
                                            <p>Jl. Raya Labuan Bajo - Ruteng KM 12</p>
                                            <p>Kabupaten Manggarai Barat, NTT</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-auto">
                            <div className="widget footer-widget">
                                <h3 className="widget_title">Statistik Pengunjung</h3>
                                <VisitorCounter />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="copyright-wrap animated-gradient"
                style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
                    backgroundSize: '300% 300%',
                    animation: 'gradientShift 8s ease infinite',
                    position: 'relative',
                    overflow: 'hidden'
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'radial-gradient(circle at 30% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 70% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)',
                        animation: 'float 6s ease-in-out infinite'
                    }}
                ></div>
                <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                    <div className="row justify-content-between align-items-center">
                        <div className="col-md-6">
                            <p className="copyright-text" style={{ color: 'white', fontWeight: '500' }}>
                                Copyright 2025 <Link to="/" style={{ color: 'white', textDecoration: 'none', fontWeight: '600' }}>Koorditel Kabupaten Manggarai Barat</Link>. All Rights
                                Reserved.
                            </p>
                        </div>
                        <div className="col-md-6 text-end d-none d-md-block">
                            <div className="footer-card" style={{
                                background: 'rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                borderRadius: '12px',
                                padding: '12px 20px',
                                display: 'inline-block'
                            }}>
                                <span className="title" style={{ color: 'white', fontSize: '12px', opacity: '0.8' }}>Dikelola Oleh</span>
                                <span className="subtitle" style={{ color: 'white', fontSize: '14px', fontWeight: '600', display: 'block' }}>Koorditel Kabupaten Manggarai Barat</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </footer>

    )
}

export default FooterOne
